<ng-container *ngIf="appConfig.getUIInfo$() | async as uiInfo">
  <div class="login__body">
    <div class="login__body__wrapper">
      <img
        [src]="
          uiInfo.customGreeterImage !== '#greeter_image#' ? uiInfo.customGreeterImage : 'assets/images/greeter.jpg'
        "
        class="login__greeter"
      />
      <div class="login__body__panel">
        <div class="login__body__panel__form">
          <h1>{{ welcomeText }}</h1>
          <ng-container *ngTemplateOutlet="loginForm"></ng-container>
        </div>
        <div class="login__logo__app">
          <img [src]="!appImgError ? appImgSrc : 'assets/images/JMeleon_Logo_2021.png'" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-text-left server-info">
        <span class="label">BE:</span>
        <span>{{ serverVersion }}</span> |
        <span class="label">UI:</span>
        <span>{{ uiVersion }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loginForm>
  <jml-lib-notifications></jml-lib-notifications>
  <form #loginForm="ngForm" (ngSubmit)="login(username.value, password.value)">
    <div class="p-fluid">
      <div class="field">
        <label>Benutzername</label>
        <input
          #username
          [disabled]="loginDisabled"
          name="username"
          id="username"
          [ngClass]="{ 'ng-dirty': loginFailed, 'ng-invalid': loginFailed }"
          type="text"
          autocomplete="off"
          placeholder="Benutzername"
          pInputText
          autofocus
        />
      </div>
      <div class="field">
        <label>Passwort</label>
        <input
          #password
          [disabled]="loginDisabled"
          name="password"
          id="password"
          [ngClass]="{ 'ng-dirty': loginFailed, 'ng-invalid': loginFailed }"
          type="password"
          autocomplete="off"
          placeholder="Passwort"
          pInputText
        />
      </div>
      <div class="button-container">
        <p-button [disabled]="loginDisabled" type="submit" id="loginBt" name="loginBt" label="Anmelden"></p-button>
      </div>
    </div>
  </form>
</ng-template>
